import { ref } from 'vue';

const RADIUS = '1.4rem';

function edgeStyle(x: number, y: number, el: HTMLElement): Record<string, string> {
  const atRight  = x + el.offsetWidth  >= window.innerWidth;
  const atLeft   = x <= 0;
  const atTop    = y <= 0;
  const atBottom = y + el.offsetHeight >= window.innerHeight;

  const tl = (!atTop  && !atLeft)  ? RADIUS : '0';
  const tr = (!atTop  && !atRight) ? RADIUS : '0';
  const br = (!atBottom && !atRight) ? RADIUS : '0';
  const bl = (!atBottom && !atLeft)  ? RADIUS : '0';

  return {
    borderRadius:       `${tl} ${tr} ${br} ${bl}`,
    borderTopWidth:    atTop    ? '0' : '1px',
    borderRightWidth:  atRight  ? '0' : '1px',
    borderBottomWidth: atBottom ? '0' : '1px',
    borderLeftWidth:   atLeft   ? '0' : '1px',
    borderTopStyle:    'solid',
    borderRightStyle:  'solid',
    borderBottomStyle: 'solid',
    borderLeftStyle:   'solid',
  };
}

export function useDraggable() {
  const isDragging = ref(false);
  const hasMoved   = ref(false);
  const dragStyle  = ref<Record<string, string>>({});

  function startDrag(e: MouseEvent, el: HTMLElement) {
    if (window.innerWidth < 1024) return;

    e.preventDefault();

    const rect    = el.getBoundingClientRect();
    const offsetX = e.clientX - rect.left;
    const offsetY = e.clientY - rect.top;

    dragStyle.value = {
      top: `${rect.top}px`, left: `${rect.left}px`,
      right: 'auto', transform: 'none',
      ...edgeStyle(rect.left, rect.top, el),
    };

    isDragging.value = true;

    function onMove(ev: MouseEvent) {
      hasMoved.value = true;

      const x = Math.max(0, Math.min(ev.clientX - offsetX, window.innerWidth  - el.offsetWidth));
      const y = Math.max(0, Math.min(ev.clientY - offsetY, window.innerHeight - el.offsetHeight));

      dragStyle.value = {
        top: `${y}px`, left: `${x}px`,
        right: 'auto', transform: 'none',
        ...edgeStyle(x, y, el),
      };
    }

    function onUp() {
      isDragging.value = false;
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup',   onUp);
    }

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup',   onUp);
  }

  return { isDragging, hasMoved, dragStyle, startDrag };
}
